'use client';

import { Suspense, useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { authClient } from '@/lib/auth-client';

function SignInRedirect() {
  const searchParams = useSearchParams();
  const callbackURL = searchParams.get('callback') ?? '/';
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        await authClient.signIn.oauth2({
          providerId: 'pocketid',
          callbackURL,
          errorCallbackURL: '/sign-in?error=oauth_failed',
        });
      } catch (e) {
        if (!cancelled) setError((e as Error).message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [callbackURL]);

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 16,
        padding: 40,
        color: 'var(--foreground)',
        fontFamily: 'var(--font-geist-sans)',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          fontFamily: 'var(--font-geist-mono)',
          fontSize: 11,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'var(--muted-foreground)',
        }}
      >
        Sign in
      </div>
      <div style={{ fontSize: 14 }}>
        {error ? <span style={{ color: 'var(--destructive)' }}>Error: {error}</span> : 'Redirecting…'}
      </div>
    </main>
  );
}

export default function SignInPage() {
  return (
    <Suspense fallback={null}>
      <SignInRedirect />
    </Suspense>
  );
}
